export default __webpack_public_path__ + "static/media/mprojectfeature2.c0b58835.png";